import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fileDownload from 'js-file-download';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Media } from 'reactstrap';

import { projectApi } from '../../../helpers/api/projectApi';
import { showErrorsFromRequest } from '../../../helpers/api/showErrorsFromRequest';
import { deleteConfirmationToast } from '../../../components/deleteConfirmationToast';
import AppContext from '../../../context/Context';
import { UserRole } from '../../../helpers/enums/userRoleEnum';
import { PermissionType } from '../../../helpers/enums/permissionTypeEnum';
import CheckUserPermissions from '../../../hoc/checkUserPermissions';

const SharedFile = ({ file, userName, isLast, setUpdateAttachments }) => {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const { name, time } = file;
  const { user } = useContext(AppContext);

  const handleFileDownload = async () => {
    const formData = new FormData();

    formData.append('file', file);
    try {
      const response = await projectApi.downloadProjectAttachment(
        projectId,
        file.id
      );
      fileDownload(response.data, name);
    } catch (error) {
      showErrorsFromRequest(error, t);
    }
  };

  const deleteFile = async () => {
    try {
      await projectApi.deleteProjectAttachment(projectId, file.id);
      toast.success(t('File deleted successfully'));
      setUpdateAttachments(true);
    } catch (error) {
      showErrorsFromRequest(error, t);
    }
  };

  const showDeleteConfirmationToast = () => {
    deleteConfirmationToast({
      title: `${t('Please confirm you want to remove')}`,
      subtitle: t("This action can't be reverted!"),
      onClick: () => deleteFile(),
      buttonText: t('Yes, delete!')
    });
  };

  return (
    <>
      <Media className="mb-3 hover-actions-trigger align-items-center">
        <Media body className="ml-3">
          <h6 className="mb-1">
            <Link
              className="stretched-link text-900 font-weight-semi-bold text-break"
              onClick={handleFileDownload}
              to="#"
            >
              {name}
            </Link>
          </h6>
          <div className="fs--1">
            <span className="font-weight-semi-bold">{userName}</span>
            <span className="font-weight-medium text-600 ml-2">{time}</span>
          </div>
          <CheckUserPermissions permissions={[PermissionType.ATTACHMENT.DELETE]}>
            <div className="hover-actions r-0 absolute-vertical-center">
              <Button
                size="sm"
                className="border-300 text-600 bg-danger"
                onClick={showDeleteConfirmationToast}
              >
                <FontAwesomeIcon icon="trash" className="text-white" />
              </Button>
            </div>
          </CheckUserPermissions>
        </Media>
      </Media>
      {!isLast && <hr className="border-200" />}
    </>
  );
};

export default SharedFile;
